module.exports = __webpack_public_path__ + "static/media/weight.849a2b1e.svg";